import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Grid from './index.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "wrappable-fluid-grid"
    }}>{`Wrappable Fluid Grid`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Grid} mdxType="Props" />
    <h2 {...{
      "id": "simplest-usage"
    }}>{`Simplest usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import Grid from 'react-wrappable-fluid-grid';
`}</code></pre>
    <Playground __position={1} __code={'<Grid data={[1, 2, 3]}>{n => n}</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[1, 2, 3]} mdxType="Grid">{n => n}</Grid>
    </Playground>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`Start By:`}</p>
    <ol>
      <li parentName="ol">{`Input data array`}</li>
      <li parentName="ol">{`Define gap spacing in px`}</li>
      <li parentName="ol">{`Define minimum column width`}</li>
    </ol>
    <p><strong parentName="p">{` Resize the screen to try it out `}</strong></p>
    <Playground __position={2} __code={'<Grid\n  data={[\n    { value: 1 },\n    { value: 2 },\n    { value: 3 },\n    { value: 4 },\n    { value: 5 },\n    { value: 6 },\n  ]}\n  gap={10}\n  minColWidth={100}\n>\n  {({ value }) => {\n    return (\n      <div style={{ background: \'#efefef\', textAlign: \'center\' }}>\n        {value}\n      </div>\n    )\n  }}\n</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[{
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }]} gap={10} minColWidth={100} mdxType="Grid">
    {({
          value
        }) => {
          return <div style={{
            background: '#efefef',
            textAlign: 'center'
          }}>
          {value}
        </div>;
        }}
  </Grid>
    </Playground>
    <h2 {...{
      "id": "specifing-a-maximum-column-width"
    }}>{`Specifing a Maximum Column Width`}</h2>
    <Playground __position={3} __code={'<Grid\n  data={[\n    { value: 1 },\n    { value: 2 },\n    { value: 3 },\n    { value: 4 },\n    { value: 5 },\n    { value: 6 },\n  ]}\n  gap={10}\n  minColWidth={250}\n  maxColWidth={300}\n>\n  {({ value }, i, columnWidth) => {\n    return (\n      <div style={{ background: \'#efefef\', textAlign: \'center\' }}>\n        {value}\n        <div style={{ fontSize: \'0.7rem\' }}>\n          width: {columnWidth.toFixed(2)}\n        </div>\n      </div>\n    )\n  }}\n</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[{
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }]} gap={10} minColWidth={250} maxColWidth={300} mdxType="Grid">
    {({
          value
        }, i, columnWidth) => {
          return <div style={{
            background: '#efefef',
            textAlign: 'center'
          }}>
          {value}
          <div style={{
              fontSize: '0.7rem'
            }}>
            width: {columnWidth.toFixed(2)}
          </div>
        </div>;
        }}
  </Grid>
    </Playground>
    <h2 {...{
      "id": "custom-horizontal-and-vertical-gap-spacing"
    }}>{`Custom Horizontal and Vertical Gap Spacing`}</h2>
    <Playground __position={4} __code={'<Grid\n  data={[\n    { value: 1 },\n    { value: 2 },\n    { value: 3 },\n    { value: 4 },\n    { value: 5 },\n    { value: 6 },\n  ]}\n  gap={{\n    x: 10,\n    y: 50,\n  }}\n  minColWidth={160}\n  maxColWidth={200}\n>\n  {({ value }, i, columnWidth) => {\n    return (\n      <div style={{ background: \'#efefef\', textAlign: \'center\' }}>\n        {value}\n        <div style={{ fontSize: \'0.7rem\' }}>\n          width: {columnWidth.toFixed(2)}\n        </div>\n      </div>\n    )\n  }}\n</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[{
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }]} gap={{
        x: 10,
        y: 50
      }} minColWidth={160} maxColWidth={200} mdxType="Grid">
    {({
          value
        }, i, columnWidth) => {
          return <div style={{
            background: '#efefef',
            textAlign: 'center'
          }}>
          {value}
          <div style={{
              fontSize: '0.7rem'
            }}>
            width: {columnWidth.toFixed(2)}
          </div>
        </div>;
        }}
  </Grid>
    </Playground>
    <h2 {...{
      "id": "custom-column-width-weightings"
    }}>{`Custom Column Width Weightings`}</h2>
    <p>{`description: weighted average of column width's min/max balance.`}<br parentName="p"></br>{`
`}{`1 is more lenient towards maximum column width, meaning wider columns.`}<br parentName="p"></br>{`
`}{`0 is more lenient towards minimum column width, meaning skinnier columns`}</p>
    <p>{`value: from 0 to 1`}<br parentName="p"></br>{`
`}{`defaultValue: 0.5`}</p>
    <h3 {...{
      "id": "weight--1"
    }}>{`Weight = 1`}</h3>
    <Playground __position={5} __code={'<Grid\n  data={[\n    { value: 1 },\n    { value: 2 },\n    { value: 3 },\n    { value: 4 },\n    { value: 5 },\n    { value: 6 },\n  ]}\n  gap={10}\n  minColWidth={160}\n  maxColWidth={200}\n  minMaxWeight={1}\n>\n  {({ value }, i, columnWidth) => {\n    return (\n      <div style={{ background: \'#efefef\', textAlign: \'center\' }}>\n        {value}\n        <div style={{ fontSize: \'0.7rem\' }}>\n          width: {columnWidth.toFixed(2)}\n        </div>\n      </div>\n    )\n  }}\n</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[{
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }]} gap={10} minColWidth={160} maxColWidth={200} minMaxWeight={1} mdxType="Grid">
    {({
          value
        }, i, columnWidth) => {
          return <div style={{
            background: '#efefef',
            textAlign: 'center'
          }}>
          {value}
          <div style={{
              fontSize: '0.7rem'
            }}>
            width: {columnWidth.toFixed(2)}
          </div>
        </div>;
        }}
  </Grid>
    </Playground>
    <h3 {...{
      "id": "weight--0"
    }}>{`Weight = 0`}</h3>
    <Playground __position={6} __code={'<Grid\n  data={[\n    { value: 1 },\n    { value: 2 },\n    { value: 3 },\n    { value: 4 },\n    { value: 5 },\n    { value: 6 },\n  ]}\n  gap={10}\n  minColWidth={160}\n  maxColWidth={200}\n  minMaxWeight={0}\n>\n  {({ value }, i, columnWidth) => {\n    return (\n      <div style={{ background: \'#efefef\', textAlign: \'center\' }}>\n        {value}\n        <div style={{ fontSize: \'0.7rem\' }}>\n          width: {columnWidth.toFixed(2)}\n        </div>\n      </div>\n    )\n  }}\n</Grid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Grid,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Grid data={[{
        value: 1
      }, {
        value: 2
      }, {
        value: 3
      }, {
        value: 4
      }, {
        value: 5
      }, {
        value: 6
      }]} gap={10} minColWidth={160} maxColWidth={200} minMaxWeight={0} mdxType="Grid">
    {({
          value
        }, i, columnWidth) => {
          return <div style={{
            background: '#efefef',
            textAlign: 'center'
          }}>
          {value}
          <div style={{
              fontSize: '0.7rem'
            }}>
            width: {columnWidth.toFixed(2)}
          </div>
        </div>;
        }}
  </Grid>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      